import { createStyles, rem } from '@mantine/core'

export default createStyles((theme) => {
  return {
    root: {
      padding: `${rem(12)} ${rem(16)}`,
      textAlign: 'left',
      borderRadius: rem(4),
      backgroundColor: theme.colors.yellow[0],
    },
    icon: {
      display: 'inline-block',
      verticalAlign: 'middle',
      marginRight: rem(4),
      [theme.fn.largerThan('sm')]: {
        marginRight: rem(8),
      },
    },
    title: {},
    content: {},
  }
})
